import React from "react"
import { NumberField, NumberFieldProps, useRecordContext } from 'react-admin';
import get from 'lodash/get';

export interface CustomNumberFieldProps extends NumberFieldProps {
    divisor?: number;
    withNegatives?: boolean;
}
const CustomNumberField = (props: CustomNumberFieldProps) => {
    const { source, divisor = 1, withNegatives = false } = props

    const m = withNegatives ? Number.NEGATIVE_INFINITY : 0
    const record = useRecordContext(props);
    const value = get(record, source!);
    if (value == null) {
        return <NumberField {...props} record={{ ...record, [source!]: '-' }} />
    } else {
        const newRecord = { ...record, [source!]: value > m ? value / divisor : '-' }
        return <NumberField {...props} record={newRecord} />
    }
}


export default CustomNumberField